import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=48b9ce60&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"
import style0 from "./integrations.vue?vue&type=style&index=0&id=48b9ce60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9ce60",
  null
  
)

export default component.exports